"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { PaymentController } from "@/service/newProdect";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Vue } from "vue-property-decorator";
import ItemElementShops from "@/components/virtual-desktop/elements/ItemElementShops.vue";
let PaymentNewVdInfo = class extends Vue {
  constructor() {
    super(...arguments);
    this.vdInfoList = [];
    this.loading = false;
    this.panel = false;
  }
  mounted() {
    return __async(this, null, function* () {
      let _ids = this.gerVdIds();
      this.getVdInfo(_ids);
    });
  }
  getVdInfo(ids) {
    return __async(this, null, function* () {
      try {
        if (ids.length <= 0) {
          return;
        }
        this.loading = true;
        let response = yield API.post(`api://base.auth.pro/v1/virtual-desktop-renew`, __spreadValues({
          vdIds: ids
        }, (() => {
          if (this._payment_style === "recycle") {
            return {
              isRelease: true
            };
          } else {
            return {
              isRelease: false
            };
          }
        })()));
        this.vdInfoList = response.data.datas;
        for (const virtualdesktop of this.vdInfoList) {
          if (virtualdesktop.shops) {
            for (const shop of virtualdesktop.shops.datas) {
              shop["icon"] = shop.logo;
            }
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.loading = false;
      }
    });
  }
  //获取vd id
  gerVdIds() {
    let _ids = [];
    for (let item of this._options.selected.virtualDesktopInfo) {
      _ids.push(item.id);
    }
    return _ids;
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewVdInfo.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentStyle", {
    default: function() {
      return "";
    }
  })
], PaymentNewVdInfo.prototype, "_payment_style", 2);
PaymentNewVdInfo = __decorateClass([
  Component({
    components: {
      ItemElementShops
    }
  })
], PaymentNewVdInfo);
export {
  PaymentNewVdInfo as default
};
